import { IFormViewForm } from 'components/FormView';

const LoadPurchaseOrderForm: IFormViewForm = {
    id: 'LoadPurchaseOrderForm',
    layout: {
        rows: 1,
        columns: 1
    },
    fields: [
        {
            id: '1',
            position: {
                row: 1,
                col: 1,
                colspan: 3
            },
            type: 'PAPER_CONTAINER',
            props: {
                elevation: 0
            },
            children: [
                {
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Supplier',
                        name: 'SupplierId',
                        size: 'small',
                        lookupName: 'Supplier',
                        required: true,
                        isSupplierScoped: true
                    }
                },
                {
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Warehouse',
                        name: 'Warehouse',
                        size: 'small',
                        lookupName: 'WarehouseEntity',
                        isCustomerScoped: true,
                        isLookupTypeFixed: true,
                        required: true,
                    }
                },
                {
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'User ID',
                        name: 'UserId',
                        size: 'small',
                        lookupName: 'Personnel',
                        isLookupTypeFixed: true,
                        required: true,
                    }
                },
                {
                    type: 'DIVIDER',
                    props: {
                    }
                },
                {
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Load from purchase order',
                        name: 'LoadFromPurchaseOrder',
                        size: 'small',
                        lookupName: 'SupplierPurchaseOrder',
                        isLookupTypeFixed: true,
                        searchScreenTitle: 'Purchase Order Lookup',
                        isSupplierScoped: true,
                        suppressDescription: true,
                    }
                },
                {
                    type: 'TOGGLE_FIELD',
                    props: {
                        label: 'Load order notes and comments',
                        name: 'LoadNotesAndComments',
                        defaultValue: false,
                    }
                },
                {
                    type: 'TOGGLE_FIELD',
                    props: {
                        label: 'Load products',
                        name: 'LoadProducts',
                        defaultValue: false,
                    }
                }
            ]
        }
    ]
};
export default LoadPurchaseOrderForm;
